import { render, staticRenderFns } from "./MiniConifg.vue?vue&type=template&id=3e93e6a2&"
import script from "./MiniConifg.vue?vue&type=script&lang=js&"
export * from "./MiniConifg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MiniConifg.vue"
export default component.exports